module.exports = {
	"header.logo.title": "GROHE SmartControl douche-keuzehulp",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.nl/nl_nl/bedrijf/privacy.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": "https://www.grohe.nl/nl_nl/privacybeleid.html",
	"footer.copyright": "© 2017 Grohe Nederland B.V.",
	"homepage.headline": "GROHE Blue voor gekoeld en/of bruisend water of GROHE Red voor kokend heet water?",
	"homepage.introtext": "Beantwoord een paar eenvoudige vragen en ontdek welk GROHE product het beste bij jouw individuele behoeften past.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"configurator.button.seeResults": "Bekijk resultaten",
	"question1.question": "Wat voor watervoorziening heb je nu in de keuken. Koud of warm?",
	"question1.option1.text": "Ik heb zowel koud en warm water",
	"question1.option2.text": "Ik heb alleen koud water",
	"question2.question": "Naar wat voor oplossing ben je op zoek?",
	"question2.option1.text": "Kokend heet water voor het bereiden van voedsel en dranken",
	"question2.option2.text": "Gekoeld en bruisend water om te drinken",
	"question2.option3.text": "Zowel gekoeld en bruisend water als kokend heet water",
	"question3.question": "Wil je jouw bestaande keukenkraan houden?",
	"question3.option1.text": "Ik wil mijn huidige kraan houden",
	"question3.option2.text": "Ik wil mijn huidige kraan vervangen door een nieuwe",
	"question4.question": "Welke keukenkraan wordt de mengkraan?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Wat is jouw favoriete uitloop?",
	"question5.option1.text": "Ik wil graag een L-uitloop",
	"question5.option2.text": "Ik wil graag een U-uitloop",
	"question5.option3.text": "Ik wil graag een C-uitloop",
	"question6.question": "What's your prefered spout design for the GROHE Red Mono tap?",
	"question6.option1.text": "L-shaped spout",
	"question6.option2.text": "C-shaped spout",
	"question7.question": "Naar welke kleur gaat jouw voorkeur uit?",
	"question7.option1.text": "Ik kies voor Chroom",
	"question7.option2.text": "Ik kies voor Supersteel",
	"question8.question": "Which boiler size do you need?",
	"question8.option1.text": "M Size (3 Litres)",
	"question8.option2.text": "L Size (5.5 Litres)",
	"question9.question": "Bij een waterhardheid hoger dan 10 dH heb je de optie om een filter toevoegen voor optimale bescherming tegen kalkafzetting en onzuiverheden? Wil je deze toevoegen?",
	"question9.option1.text": "Ja",
	"question9.option2.text": "Nee",
	"results.title": "{productGroupsCount, plural, \none {Jouw resultaat} \nother {Jouw resultaten}\n}",
	"results.bundle.title": "Voor een correcte installatie heb je ook nodig:",
	"results.newConfiguration.buttonText": "Begin opnieuw",
	"results.product.button.productInformation": "Productinformatie",
	"results.product.button.dealerLocator": "Zoek verkooppunt",
	"results.product.button.buyNow": "Koop online",
	"results.product.information": "Productinformatie",
	"results.product.dealer": "Zoek verkooppunt",
	"results.proposal.title": "Advies {number}",
	"results.proposal.title.single": "Advies",
	"results.newConfiguration.title": "Wil je opnieuw beginnen?",
	"results.product.number": "Artikelnummer: #{number}",
	"results.product.button.downloadPDF": "Download advies (PDF)",
	"404.title": "404 Pagina niet gevonden",
	"404.link.goBack": "Terug naar de homepage",
	"hatchModal.title": "Koop online",
	"hatchModal.btnText": "Nu kopen",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Niet op voorraat} \nother {Op voorraad}\n}",
	"hatchModal.buyNow": "Nu kopen",
	"app.components.HomePage.header": "GROHE SmartControl douche-keuzehulp"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.nl_nl.json
// module id = 788
// module chunks = 0